import { useLocation, useNavigate } from 'react-router-dom'
import { useCommonCMSConfig } from '~api'
import { Routes } from '~constants/routes'

const DEFAULT_LOCATION_KEY = 'default'

function useDefaultHandleBack() {
    const { hideMarketPage } = useCommonCMSConfig()?.data?.features || {}
    const navigate = useNavigate()
    const location = useLocation()

    return () => {
        const canNavigateBack = location.key !== DEFAULT_LOCATION_KEY

        if (canNavigateBack) {
            navigate(-1)
        } else {
            const redirectPage = hideMarketPage ? Routes.wallet : Routes.market

            navigate(`/${redirectPage}`)
        }
    }
}

export default useDefaultHandleBack
